module.exports = __webpack_public_path__ + "static/media/Location_Book-Page41.8c8ed581.png";